module.exports = __webpack_public_path__ + "static/img/az_xz.b08dae3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/az_xz.png
// module id = tsvE
// module chunks = 1